import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ num, label }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={`chapter-tag-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <span className="font-mono text-xs tracking-[0.3em] text-cyan">{num}</span>
      <span className="h-px w-12 bg-cyan/40" />
      <span className="font-mono text-xs tracking-[0.3em] text-neutral-500 uppercase">{label}</span>
    </div>
  </Reveal>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={inView ? { y: 0 } : {}}
        transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};
